<div class="trg-toggle trg-toggle__{{color ?? 'default'}}"
     [class.off]="isOff"
     [class.on]="isOn"
     [class.trg-toggle__small]="size === 'small'"
     [class.disabled]="disabled"
     (click)="toggle()">
  <div class="text">
    <div class="on-text">
      <span>{{onText}}</span>
    </div>
    <div class="off-text">
      <span>{{offText}}</span>
    </div>
  </div>
  <div class="circle"></div>
</div> 
